import { Utils } from "@/plugins/utils";

export default {
    namespaced: true,
    state: {
        loading: false,
    },
    getters: {
        
    },
    mutations: {

    },
    actions: {
        async condicaovalida(store, { conpgto, lista }){
            if (!conpgto || !lista) 
                return false
                
            store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Validando condição de pagamento", indeterminate: true }, {root: true})
            let payload = await this._vm.$axios.get(`/Oryx/Fiscal/CondicaoValida/${conpgto}/${lista}`)
            .then(response => {
                return Utils.ValidateAxiosResponse(response.data);
            })
            .catch((error) => {
                store.dispatch("parameters/openDialog", {
                    titleText: "Erro",
                    titleColor: "red",
                    text: error.message
                }, { root: true })
                return false
            });
            store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, {root: true})
            return payload
        },

        async generateFileEstablishment(store){
            store.state.loading = true
            store.dispatch("parameters/showSnackBar", {
                show: true,
                loading: true,
                text: "Gerando arquivos...",
                timeout: -1,
            }, { root: true })

            let payload = await this._vm.$axios.get("/Fiscal/FiscalPaf/FindOwnerEstablishment")

            .then(response => {
                const path = Utils.ValidateAxiosResponse(response.data);
                store.dispatch("print/exportedFile", "Identificacao_do_estabelecimento_usuario_PAF_NFCe.txt" , { root: true })
            }).catch((error) => {
                store.dispatch("parameters/openDialog", {
                    titleText: "Erro",
                    titleColor: "red",
                    text: error.message
                }, { root: true })
            });
            store.dispatch("parameters/showSnackBar", { showLoadingGlobal: false, text: "" }, {root: true})
            store.state.loading = false
            return payload
        },

        async generateFilePaymentMethods(store) {
            store.state.loading = true
            store.dispatch("parameters/showSnackBar", {
                show: true,
                loading: true,
                text: "Gerando arquivos...",
                timeout: -1,
            }, { root: true })

            let payload = await this._vm.$axios.get("/Fiscal/FiscalPaf/PaymentMethods")

            .then(response => {
                const path = Utils.ValidateAxiosResponse(response.data);
                store.dispatch("print/exportedFile", "Total_Diario_de_Meios_de_Pagamento.txt" , { root: true })
            }).catch((error) => {
                store.dispatch("parameters/openDialog", {
                    titleText: "Erro",
                    titleColor: "red",
                    text: error.message
                }, { root: true })
            });
            store.dispatch("parameters/showSnackBar", { showLoadingGlobal: false, text: "" }, {root: true})
            store.state.loading = false
            return payload
        },

        async generateFileProducts(store) {
            store.state.loading = true
            store.dispatch("parameters/showSnackBar", {
                show: true,
                loading: true,
                text: "Gerando arquivos...",
                timeout: -1,
            }, { root: true })

            let payload = await this._vm.$axios.get("/Fiscal/FiscalPaf/FindProducts")

            .then(response => {
                const path = Utils.ValidateAxiosResponse(response.data);
                store.dispatch("print/exportedFile", "Relacao_Das_Mercadorias_e_Servicos.txt" , { root: true })
            }).catch((error) => {
                store.dispatch("parameters/openDialog", {
                    titleText: "Erro",
                    titleColor: "red",
                    text: error.message
                }, { root: true })
            });
            store.dispatch("parameters/showSnackBar", { showLoadingGlobal: false, text: "" }, {root: true})
            store.state.loading = false
            return payload
        },

        async generateFileStock(store, lstSelectedStock) {
            store.state.loading = true
            store.dispatch("parameters/showSnackBar", {
                show: true,
                loading: true,
                text: "Gerando arquivos...",
                timeout: -1,
            }, { root: true })

            let queryText = "";
            lstSelectedStock.forEach((Pr0produto) => { queryText += `lstSelectedStock=${Pr0produto}&`;});

            let payload = await this._vm.$axios.get(`/Fiscal/FiscalPaf/FindStock?${queryText}`)

            .then(response => {
                const path = Utils.ValidateAxiosResponse(response.data);
                store.dispatch("print/exportedFile", "Relacao_Das_Mercadorias_Em_Estoque.txt" , { root: true })
            }).catch((error) => {
                store.dispatch("parameters/openDialog", {
                    titleText: "Erro",
                    titleColor: "red",
                    text: error.message
                }, { root: true })
            });
            store.dispatch("parameters/showSnackBar", { showLoadingGlobal: false, text: "" }, {root: true})
            store.state.loading = false
            return payload
        },

        async generateFileNfce(store) {
            store.state.loading = true
            store.dispatch("parameters/showSnackBar", {
                show: true,
                loading: true,
                text: "Gerando arquivos...",
                timeout: -1,
            }, { root: true })

            let payload = await this._vm.$axios.get("/Fiscal/FiscalPaf/FindNfce")

            .then(response => {
                const path = Utils.ValidateAxiosResponse(response.data);
                store.dispatch("print/exportedFile", "NFCe_Emitida_Pelo_PAF_NFCe.txt" , { root: true })
            }).catch((error) => {
                store.dispatch("parameters/openDialog", {
                    titleText: "Erro",
                    titleColor: "red",
                    text: error.message
                }, { root: true })
            });
            store.dispatch("parameters/showSnackBar", { showLoadingGlobal: false, text: "" }, {root: true})
            store.state.loading = false
            return payload
        },

        async generateFileContingencyNfce(store) {
            store.state.loading = true
            store.dispatch("parameters/showSnackBar", {
                show: true,
                loading: true,
                text: "Gerando arquivos...",
                timeout: -1,
            }, { root: true })

            let payload = await this._vm.$axios.get("/Fiscal/FiscalPaf/FindContingencyNfce")

            .then(response => {
                const path = Utils.ValidateAxiosResponse(response.data);
                store.dispatch("print/exportedFile", "NFCe_Emitida_em_contingencia_pelo_PAF_NFCe.txt" , { root: true })
            }).catch((error) => {
                store.dispatch("parameters/openDialog", {
                    titleText: "Erro",
                    titleColor: "red",
                    text: error.message
                }, { root: true })
            });
            store.dispatch("parameters/showSnackBar", { showLoadingGlobal: false, text: "" }, {root: true})
            store.state.loading = false
            return payload
        },

        async generateFileOwnerUser(store){
            store.state.loading = true
            store.dispatch("parameters/showSnackBar", {
                show: true,
                loading: true,
                text: "Gerando arquivos...",
                timeout: -1,
            }, { root: true })

            let payload = await this._vm.$axios.get("/Fiscal/FiscalPaf/FindOwnerUser")

            .then(response => {
                const path = Utils.ValidateAxiosResponse(response.data);
                store.dispatch("print/exportedFile", "Identificacao_do_usuario_PAF_NFCe.txt" , { root: true })
            }).catch((error) => {
                store.dispatch("parameters/openDialog", {
                    titleText: "Erro",
                    titleColor: "red",
                    text: error.message
                }, { root: true })
            });
            store.dispatch("parameters/showSnackBar", { showLoadingGlobal: false, text: "" }, {root: true})
            store.state.loading = false
            return payload
        },

        async generateFileDeveloperCompanyIdentification(store) {
            store.state.loading = true
            store.dispatch("parameters/showSnackBar", {
                show: true,
                loading: true,
                text: "Gerando arquivos...",
                timeout: -1,
            }, { root: true })

            let payload = await this._vm.$axios
            .get("/Fiscal/FiscalPaf/DeveloperCompanyIdentification")
            .then(response => {
                const path = Utils.ValidateAxiosResponse(response.data);
                store.dispatch("print/exportedFile", "Identificacao_Da_Empresa_Desenvolvedora_do_PAF_NFCe.txt" , { root: true })})
            .catch((error) => {
                store.dispatch("parameters/openDialog", {
                    titleText: "Erro",
                    titleColor: "red",
                    text: error.message
                }, { root: true })
            });
            store.dispatch("parameters/showSnackBar", { showLoadingGlobal: false, text: "" }, {root: true})
            store.state.loading = false
            return payload
        },

        async generateFilePafIdentification(store, systemVersion) {
            store.state.loading = true
            store.dispatch("parameters/showSnackBar", {
                show: true,
                loading: true,
                text: "Gerando arquivos...",
                timeout: -1,
            }, { root: true })

            let payload = await this._vm.$axios
            .get(`/Fiscal/FiscalPaf/PafIdentification/${systemVersion}`)
            .then(response => {
                const path = Utils.ValidateAxiosResponse(response.data);
                store.dispatch("print/exportedFile", "Identificacao_Do_PAF_NFCe.txt" , { root: true })})
            .catch((error) => {
                store.dispatch("parameters/openDialog", {
                    titleText: "Erro",
                    titleColor: "red",
                    text: error.message
                }, { root: true })
            });
            store.dispatch("parameters/showSnackBar", { showLoadingGlobal: false, text: "" }, {root: true})
            store.state.loading = false
            return payload
        },

        async generateFileTotalizationPaf(store) {
            store.state.loading = true
            store.dispatch("parameters/showSnackBar", {
                show: true,
                loading: true,
                text: "Gerando arquivos...",
                timeout: -1,
            }, { root: true })

            let payload = await this._vm.$axios.get("/Fiscal/FiscalPaf/TotalizationPaf")
            .then(response => {
                const path = Utils.ValidateAxiosResponse(response.data);
                store.dispatch("print/exportedFile", "Total_De_Saidas_PAF_NFCe.txt" , { root: true })})
            .catch((error) => {
                store.dispatch("parameters/openDialog", {
                    titleText: "Erro",
                    titleColor: "red",
                    text: error.message
                }, { root: true })
            });
            store.dispatch("parameters/showSnackBar", { showLoadingGlobal: false, text: "" }, {root: true})
            store.state.loading = false
            return payload
        },

        async generateFileSumTotalizationPaf(store) {
            store.state.loading = true
            store.dispatch("parameters/showSnackBar", {
                show: true,
                loading: true,
                text: "Gerando arquivos...",
                timeout: -1,
            }, { root: true })

            let payload = await this._vm.$axios.get("/Fiscal/FiscalPaf/FileTotalizationPaf")
            .then(response => {
                const path = Utils.ValidateAxiosResponse(response.data);
                store.dispatch("print/exportedFile", "Totalizacao_PAF_NFCe.txt" , { root: true })})
            .catch((error) => {
                store.dispatch("parameters/openDialog", {
                    titleText: "Erro",
                    titleColor: "red",
                    text: error.message
                }, { root: true })
            });
            store.dispatch("parameters/showSnackBar", { showLoadingGlobal: false, text: "" }, {root: true})
            store.state.loading = false
            return payload
        }
        
    }
}